export { NumeralPluralsPipe } from './numeral-plurals.pipe';
